"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMenu = void 0;
var AuthMenu_1 = require("./AuthMenu");
Object.defineProperty(exports, "AuthMenu", { enumerable: true, get: function () { return __importDefault(AuthMenu_1).default; } });
